export const PATHS = {
  home: "/",
  library: "/library",
  pricing: "/pricing",
  unsubscribe: "/unsubscribe",
  login: "/login",
  signup: "/signup",
  forgotPassword: "/forgot",
  privacy: "/privacy",
  terms: "/terms",
  account: "/account",
} as const;
